<app-nav-left *ngIf="showNavHeader"></app-nav-left>
<app-header *ngIf="showNavHeader"></app-header>
<router-outlet></router-outlet> 

